<template>
    <v-content>
        <v-breadcrumbs :items="breadCrumbs" large></v-breadcrumbs>
        <div>
         
            <v-row>
         
                <v-col xl="2" md="3" sm="6" cols="12" v-for="title in sidebarMenu"
                       v-bind:key="title.link"
                       class="viewCard">

                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <router-link :to="title.link">
                                <HoverCard :cardData="{icon:title.icon,name:title.menuName}"></HoverCard>
                            </router-link>
                        </template>
                    </v-tooltip>


                </v-col>
            </v-row>
        </div>
    </v-content>


</template>
<script>
    import store from "../../store";
    import { mapGetters } from "vuex";
    //import SetupCard from '@/components/SetupCard'
    import HoverCard from "@/components/HoverCard";


    export default {
        name: "SideBar",
        props: ["userInfo"],
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                sidebarMenu: 'getSidebarMenu',
                usersData: 'getUserData',
            }),
        },

        data: () => ({
            user: {},
            menuItems: [],
            breadCrumbs: [],
        }),
        created() {
            this.breadCrumb(),
            this.getMenu();
        
        },
        methods: {

            getMenu() {
                let userData = JSON.parse(store.getters.getInfo);
                this.user.name = userData.userName;

            },
            breadCrumb() {
                this.breadCrumbs = [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true

                    },
                    {
                        text: 'Setting',
                        disabled: true,
                    },
                ]
            },
        },
        components: {
          HoverCard,
            //SetupCard

        }
    };
</script>
<style lang="scss">


    .v-avatar {
        margin-left: -0.4em;

        .v-icon {
            color: $main-color;
            font-size: 2.5em;
        }
    }
</style>
